import React from "react";

const Education = () => {
	return (
		<section id="education-section" className="section">
			<h2>Education</h2>
			<div className="flex" />
			<article className="flex-item">
				<h3>
					Indiana University <small className="date">2015 - 2017</small>
				</h3>
				<p>Masters of Business Administration (MBA)</p>
			</article>
			<article className="flex-item">
				<h3>
					Indiana University <small className="date">2008 - 2011</small>
				</h3>
				<p>B.S. Informatics</p>
			</article>
		</section>
	);
};

export default Education;
